import { Empresa } from './../models/empresa';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';

import 'rxjs/add/operator/map';
import { Usuario } from '../models/usuario';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  constructor(
    public http: HttpClient
  ) { }



  crearempresaformulario( empresa: Empresa ) {
    let url = URL_SERVICIOS + '/empresa/capturainfo';
    return this.http.post ( url , empresa)
    .map (( resp: any ) => {
     alert ('Your information has been received.  You will be notified by email once you are authorized');
    });


  }






  modificaempresausuario( empresa: Empresa, id: string ) {
    let url = URL_SERVICIOS + '/empresa/' + id;
    return this.http.put ( url , empresa);
    // .map (( resp: any ) => {
    //  alert ('Your information has been received.  You will be notified by email once you are authorized');
    // });

  }


  modificastatusempresactivada( datos: Usuario, id: string, estadovalidacion: boolean ) {
    let url = URL_SERVICIOS + '/empresa/activa_validacion/' + id + '/' + estadovalidacion;
    return this.http.put ( url,datos);
    // .map (( resp: any ) => {
    //  alert ('Your information has been received.  You will be notified by email once you are authorized');
    // });

  }


  borraempresa( id: string){
      console.log (id);
  }
}
